import { addHoursToDisplay, getUtcNowDisplay } from './datetime';

export const DEFAULT_PROPAGATION_DURATION_HOURS = 24;
export const DEFAULT_PROPAGATION_STEP_SECONDS = 10;
export const DEFAULT_PROPAGATION_STEP_SECONDS_CONFIG = 60;

export const getDefaultPropagationWindow = () => {
  const start = getUtcNowDisplay();
  return {
    start,
    end: addHoursToDisplay(start, DEFAULT_PROPAGATION_DURATION_HOURS),
  };
};

export const isPropagationConfigured = (prop: any) =>
  Boolean(
    prop &&
    Number(prop.startEpoch) > 0 &&
    Number(prop.endEpoch) > Number(prop.startEpoch) &&
    Number(prop.stepSizeSeconds) > 0
  );
